module.exports = __webpack_public_path__ + "static/media/20.c9cbf4ba.jfif";